import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { MDBContainer, MDBTypography } from "mdb-react-ui-kit";
import { SignalReport } from "../../components/SignalReportModal/SignalReport";
import { showErrorToast } from "../../helpers";
import {
  getReportWithoutAuth,
  updateStatusWithoutAuth,
} from "../../helpers/deepLink";
import { useLoader } from "stm-frontend-library";

const DeepLink = () => {
  const [data, setData] = useState(null);
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useParams();
  const { showLoader, hideLoader } = useLoader();

  const fetchData = async () => {
    if (!token) return;
    try {
      setHasError(false);
      setIsLoading(true);
      showLoader();
      const { data: response } = await getReportWithoutAuth(token);
      setData(response);
    } catch (error) {
      setHasError(true);
      showErrorToast();
    } finally {
      setIsLoading(false);
      hideLoader();
    }
  };

  const updateStatus = async ({ component, recordId, submissionStatus, additionalParams = {} }) => {
    try {
      showLoader();
      setIsLoading(true);
      await updateStatusWithoutAuth(token, {
        component,
        recordId,
        submissionStatus,
        ...additionalParams
      });
      fetchData();
    } catch (error) {
      showErrorToast();
    } finally {
      setIsLoading(false);
      hideLoader();
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <MDBContainer className="my-5">
      {!isLoading && (hasError || !data) && (
        <MDBTypography className="text-center" variant="h5">
          This submission data is unavailable
        </MDBTypography>
      )}
      {!isLoading && !hasError && data && (
        <SignalReport
          dupSubData={data.duplicateSubmissions}
          contentData={data.ambientScreening}
          updateDupSubStatus={(itemId, submissionStatus, additionalParams) =>
            updateStatus({
              component: "duplicateSubmissions",
              recordId: itemId,
              submissionStatus,
              additionalParams,
            })
          }
          updateAmbientScreeningStatus={(itemId, submissionStatus, additionalParams) =>
            updateStatus({
              component: "ambientScreening",
              recordId: itemId,
              submissionStatus,
              // additionalParams,
            })
          }
        />
      )}
    </MDBContainer>
  );
};

export default DeepLink;